import { render, staticRenderFns } from "./userfield.vue?vue&type=template&id=58511850&"
import script from "./userfield.vue?vue&type=script&lang=ts&"
export * from "./userfield.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "userfield.vue"
export default component.exports